module.exports = __webpack_public_path__ + "img/image11.dd6a7aed.jpg";